import { getEndpoint } from "@api-routes/endpoint";
import { EServiceGroup } from "@constants";
import { getAcquisitionType } from "@utils/acquisitionTypeUtils";

const MS_NAME = "bff";
const BFF_ENDPOINT = getEndpoint(MS_NAME);

export const getOfferListRoute = (reference: string) =>
    `${BFF_ENDPOINT}offers/${reference}?servicesGroup=${EServiceGroup.MOBILE}&servicesGroup=${
        EServiceGroup.SA_BB
    }&acquisitionType=${getAcquisitionType()}`;
